<template>
  <div>
    <div class="card mb-4">
      <div class="card-header">
        <h5 class="mb-0">Yeni Influencer Ekle</h5>
      </div>
      <div class="card-body">
        <form class="row g-2 align-items-center" @submit.prevent="submitInfluencer">
          <div class="col-md-3">
            <input
              v-model="form.name"
              type="text"
              class="form-control"
              placeholder="İsim *"
              required
            >
          </div>
          <div class="col-md-2">
            <input
              v-model="form.instagramHandle"
              type="text"
              class="form-control"
              placeholder="Instagram @kullanıcı"
            >
          </div>
          <div class="col-md-2">
            <input
              v-model="form.phone"
              type="text"
              class="form-control"
              placeholder="Telefon"
            >
          </div>
          <div class="col-md-2">
            <input
              v-model="form.email"
              type="email"
              class="form-control"
              placeholder="E-posta"
            >
          </div>
          <div class="col-md-2">
            <input
              v-model="form.notes"
              type="text"
              class="form-control"
              placeholder="Not"
            >
          </div>
          <div class="col-md-1">
            <button
              type="submit"
              class="btn btn-success w-100"
              :disabled="saving"
            >
              Ekle
            </button>
          </div>
        </form>
        <div v-if="errorMessage" class="text-danger mt-2">
          {{ errorMessage }}
        </div>
      </div>
    </div>

    <div class="card">
      <div class="card-header d-flex justify-content-between align-items-center">
        <h5 class="mb-0">Influencer Listesi</h5>
        <input
          v-model="search"
          type="search"
          class="form-control w-auto"
          placeholder="İsim ara..."
        >
      </div>
      <div class="card-body">
        <div v-if="loading">
          Yükleniyor...
        </div>
        <table v-else class="table table-bordered table-hover table-striped">
          <thead class="table-dark">
            <tr>
              <th>İsim</th>
              <th>Instagram</th>
              <th>Telefon</th>
              <th>E-posta</th>
              <th>Toplam Hak</th>
              <th>Kullanılan</th>
              <th>Kalan Hak</th>
              <th>Durum</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="inf in filteredInfluencers" :key="inf.id">
              <td>{{ inf.name }}</td>
              <td>{{ inf.instagramHandle }}</td>
              <td>{{ inf.phone }}</td>
              <td>{{ inf.email }}</td>
              <td>{{ inf.totalPostRights }}</td>
              <td>{{ inf.totalPostsUsed }}</td>
              <td :class="inf.remainingPostRights <= 0 ? 'text-danger fw-bold' : 'text-success fw-bold'">
                {{ inf.remainingPostRights }}
              </td>
              <td>{{ inf.active ? 'Aktif' : 'Pasif' }}</td>
            </tr>
            <tr v-if="filteredInfluencers.length === 0">
              <td colspan="8" class="text-center text-muted">
                Kayıt bulunamadı.
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'InfluencerListTab',
  data() {
    return {
      influencers: [],
      loading: true,
      saving: false,
      search: '',
      errorMessage: '',
      form: {
        name: '', instagramHandle: '', phone: '', email: '', notes: '',
      },
    };
  },
  computed: {
    filteredInfluencers() {
      if (!this.search) return this.influencers;
      const term = this.search.toLowerCase();
      return this.influencers.filter((i) => (i.name || '').toLowerCase().includes(term));
    },
  },
  mounted() {
    this.fetchInfluencers();
  },
  methods: {
    fetchInfluencers() {
      this.loading = true;
      this.axios.get(`${this.baseUrl}/influencer`, this.$store.getters.authHeader)
        .then((response) => {
          this.influencers = response.data;
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },
    submitInfluencer() {
      this.errorMessage = '';
      this.saving = true;
      this.axios.post(`${this.baseUrl}/influencer`, this.form, this.$store.getters.authHeader)
        .then(() => {
          this.form = {
            name: '', instagramHandle: '', phone: '', email: '', notes: '',
          };
          this.fetchInfluencers();
        })
        .catch((error) => {
          this.errorMessage = (error.response && error.response.data) || 'Influencer eklenirken hata oluştu.';
        })
        .finally(() => {
          this.saving = false;
        });
    },
  },
};
</script>

<style scoped>
</style>
